module.exports = __webpack_public_path__ + "img/icon-rename.ea2960d7.png";